(function () {
  "use strict";

  async function refreshCartCount() {
    const cartUrl = `${window.routes?.cartUrl || "/cart"}.js`;
    const response = await fetch(cartUrl, {
      credentials: "same-origin",
      headers: {
        "Cache-Control": "no-cache",
      },
    });

    if (!response.ok) {
      throw new Error(`Unable to refresh cart count: ${response.status}`);
    }

    const cart = await response.json();
    const cartBubble = document.querySelector(".header__cart-count");

    if (cartBubble) {
      cartBubble.textContent = cart.item_count;
      cartBubble.classList.toggle("cart-empty", cart.item_count < 1);
    }

    if (window.theme) window.theme.cartCount = cart.item_count;

    document.dispatchEvent(new CustomEvent("addToCartFinish", { detail: cart }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { data: cart } }));
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    if (!swat.evtLayer) return;

    swat.evtLayer.addEventListener("sw:addedtocart", function () {
      refreshCartCount().catch(function (error) {
        console.error("Unable to refresh the cart after adding from the wishlist", error);
      });
    });
  });
})();
